<template>
  <div>

    <data-table
      :title="titleCase(view) + ' Rates'"
      title-heading="h2"
      :url="'/rates/' + view"
      :table-ref="view + 'ratesttable'"
      :fields="fields"
      :hide-top="hideTop"
      :show-search="showSearch"
      :show-refresh="showRefresh"
      :search-placeholder="searchPlaceholder"
      :add-action="noAdd ? null : action"
      :add-props="noAdd ? null : addPropsData">

      <template slot="edit" slot-scope="props">
        <rates-action v-if="isManager('finance|management|admin')"
         :view="view" :show-range="!isUtil()" :row-data="props.rowData" />
      </template>

      <template slot="delete" slot-scope="props">
        <el-button
          v-if="isManager('finance')"
          @click="deleteRate(props.rowData)"
          type="danger"
          icon="fa fa-trash"
          circle
          size="small" />
      </template>

    </data-table>

    </div>
</template>


<script>

import NumberMixins from '@/mixins/NumberMixins'
import FormattingMixins from '@/mixins/FormattingMixins'
import PostMixins from '@/mixins/PostMixins'

import RatesAction from './actions/RatesAction'

export default {
  mixins: [FormattingMixins, NumberMixins, PostMixins],

  components: {
    RatesAction
  },

  props: {
    view: {
      type: String,
      validator: function (value) {
        return value !== null ? ['sharer', 'tenancy', 'utility'].indexOf(value) !== -1 : true
      },
      default: 'sharer'
    },

    noAdd: {
      type: Boolean,
      default: false
    },

    siteId: {
      type: Number,
      default: null
    },

    owner: {
      type: Number,
      default: null
    },

    hideTop: {
      type: Boolean,
      default: false
    },

    showSearch: {
      type: Boolean,
      default: true
    },

    showRefresh: {
      type: Boolean,
      default: true
    },

    searchPlaceholder: {
      type: String,
      default: 'Name...'

    }

  },

  methods: {
    deleteRate (row) {

      if (row.id) {
        this.deleteItem(this, row.id, '/rates', 'Delete rate ' + row.name + ' [' + row.status + ']', null, true, this.view + 'ratesttable')
      } else {
        this.$message({type: 'warning', message: 'No ID, can\'t delete.'})
      }
    },

    isTenancy () {
      return (this.view === 'tenancy')
    },

    isUtil () {
      return (this.view === 'utility')
    }
  },

  data () {

    return {
      telcoId: this.isTelco() ? Number(this.org().id) : this.owner,

      action: RatesAction,
      addPropsData: {
        rowData: this.rowData,
        editMode: false,
        view: this.view,
        tableRef: this.view + 'ratesttable',
        showRange: (this.view === 'utility' ? false : true)
      },

      fields: [
        {
          name: '__sequence',
          title: '#',
          sortField: 'id'
        },
        {
          name: 'groupId',
          title: 'group ID',
          sortField: 'groupId',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'status',
          title: 'Status',
          sortField: 'status',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'height',
          title: 'Height',
          callback: this.formatInteger,
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down',
          visible: !this.isUtil() && !this.isTenancy()
        },
        {
          name: 'users',
          title: 'Users',
          callback: this.formatInteger,
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down',
          visible: this.isUtil()
        },
        {
          name: 'cabin',
          title: 'Cabin',
          callback: this.formatInteger,
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down',
          visible: this.isUtil()
        },
        {
          name: 'name',
          title: 'Name',
          sortField: 'name',
          visible: !this.isUtil()
        },
        {
          name: 'percentIncreasePerYear',
          title: 'Incr. Per Year',
          callback: this.formatPercent,
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down',
          visible: this.isTenancy()
        },
        {
          name: 'fromMonth',
          title: 'Starting Month',
          callback: this.formatInteger,
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down',
          visible: this.isTenancy()
        },
        {
          name: 'toMonth',
          title: 'End Month',
          callback: this.formatInteger,
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down',
          visible: this.isTenancy()
        },
        {
          name: 'telco1',
          title: 'Rate #1',
          callback: this.formatNumber,
          visible: !this.isTenancy()
        },
        {
          name: 'telco2',
          title: 'Rate #2',
          callback: this.formatNumber,
          visible: !this.isTenancy()
        },
        {
          name: 'telco3',
          title: 'Rate #3',
          callback: this.formatNumber,
          visible: !this.isTenancy()
        },
        {
          name: 'telco4',
          title: 'Rate #4',
          callback: this.formatNumber,
          visible: !this.isTenancy()
        },
        {
          name: 'telco5',
          title: 'Rate #5',
          callback: this.formatNumber,
          visible: !this.isTenancy()
        },
        {
          name: 'telco6',
          title: 'Rate #6',
          callback: this.formatNumber,
          visible: !this.isTenancy()
        },
        {
          name: 'telco7',
          title: 'Rate #7',
          callback: this.formatNumber,
          visible: !this.isTenancy()
        },
        {
          name: 'telco8',
          title: 'Rate #8',
          callback: this.formatNumber,
          visible: !this.isTenancy()
        },
        {
          name: 'telco9',
          title: 'Rate #9',
          callback: this.formatNumber,
          visible: !this.isTenancy()
        },
        {
          name: 'telco10',
          title: 'Rate #10',
          callback: this.formatNumber,
          visible: !this.isTenancy()
        },
        {
          name: '__slot:edit'
        },
        {
          name: '__slot:delete'
        }
      ]
    }
  },  // data

  mounted () {
    if (!this.telcoId && this.isTelco()) {
      this.telcoId = Number(this.org().id)
    }
  }
}

</script>



// WEBPACK FOOTER //
// RatesTable.vue?39a8bdd8